let gpsInterval = null;

export function startWorkerLocationTracker(workerId) {
    if (!workerId) {
        console.log("No workerId provided → GPS tracking aborted.");
        return;
    }

    if (!navigator.geolocation) {
        console.log("GPS not supported in this browser.");
        return;
    }

    const API = process.env.REACT_APP_API_PATH || "http://localhost:8060/api/";

    async function getBatteryLevel() {
        try {
            if (navigator.getBattery) {
                const battery = await navigator.getBattery();
                return Math.round(battery.level * 100);
            }
        } catch (e) { }
        return 0;
    }

    async function sendLocationToServer(lat, lng) {
        const battery = await getBatteryLevel();

        await fetch(`${API}geo/tupdate`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                userId: workerId,
                latitude: lat,
                longitude: lng,
                accuracy: 0,
                batteryLevel: battery
            })
        })
        .catch(err => console.error("Location send error:", err));
    }

    // Prevent multiple intervals
    if (gpsInterval) {
        clearInterval(gpsInterval);
    }

    gpsInterval = setInterval(() => {
        navigator.geolocation.getCurrentPosition(
            (pos) => {
                sendLocationToServer(
                    pos.coords.latitude,
                    pos.coords.longitude
                );
            },
            (err) => {
                console.log("GPS permission denied:", err);
            },
            { enableHighAccuracy: true }
        );
    }, 20000);

    console.log("Worker GPS tracking started…");
}
